import { render, staticRenderFns } from "./cdwritobtawh.vue?vue&type=template&id=2350d8b6&scoped=true&"
import script from "./cdwritobtawh.vue?vue&type=script&lang=js&"
export * from "./cdwritobtawh.vue?vue&type=script&lang=js&"
import style0 from "./cdwritobtawh.vue?vue&type=style&index=0&id=2350d8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2350d8b6",
  null
  
)

export default component.exports